<template>
    <article class="prose" v-html="content"></article>
</template>
<script>
import { marked } from 'marked';
import {computed} from "vue";
import translate from "./../../../lang"

export default {
    props: {
    },
    setup() {
        let content = computed(() => {
            return marked(translate('privacy')('content'));
        })
        return {
            content
        }
    }
};
</script>

<style>
ol > li {
    font-weight: bold;
}
ol ~ p {
    font-weight: normal;
    padding-left: 2rem;
}
ol > li > ol >li {
    font-weight: normal;
}
</style>
